<template>
  <div class="animate-slide-down-fade-in">
    <CryptoPrice
      :logo-src="logoSrc"
      :historical-price="historicalPrice"
      :current-price="currentPrice"
      :display-date="displayDate"
    />
    <div class="flex justify-center">
      <CryptoSelector :selected-coin="store.selectedCoin" @coin-changed="handleCoinChanged" />
      <DatePicker
        :date="store.date"
        :today="today"
        :min-date="minDate"
        @date-changed="fetchHistoricalPrice"
      />
    </div>
    <div v-if="errorMessage" class="text-red-600 m-3 animate-error-shake">{{ errorMessage }}</div>
  </div>
</template>

<script>
import { fetchCurrentPrice, fetchHistoricalPrice } from '@/services/cryptoPrice';
import { store } from '@/store';
import CryptoPrice from '@/components/CryptoPrice.vue';
import CryptoSelector from '@/components/CryptoSelector.vue';
import DatePicker from '@/components/DatePicker.vue';

const minuteInMilliseconds = 60000;

export default {
  components: {
    CryptoPrice,
    CryptoSelector,
    DatePicker,
  },
  data() {
    return {
      currentPrice: 0,
      historicalPrice: null,
      errorMessage: '',
      store,
    };
  },
  computed: {
    logoSrc() {
      const logos = {
        bitcoin: '/bitcoin.svg',
        dacxi: '/dacxi.svg',
        ethereum: '/ethereum.svg',
        cosmos: '/cosmos.svg',
      };
      return logos[this.store.selectedCoin];
    },
    today() {
      return new Date().toISOString().split('T')[0];
    },
    minDate() {
      const date = new Date();
      date.setFullYear(date.getFullYear() - 1);
      return date.toISOString().split('T')[0];
    },
    displayDate() {
      if (!this.store.date) return '';
      const [year, month, day] = this.store.date.split('-');
      return `${month}/${day}/${year}`;
    },
  },
  created() {
    this.fetchCurrentPrice();
    setInterval(this.fetchCurrentPrice, minuteInMilliseconds);
  },
  methods: {
    async fetchCurrentPrice() {
      this.errorMessage = '';
      try {
        this.currentPrice = await fetchCurrentPrice(this.store.selectedCoin);
      } catch {
        this.handleError();
      }
    },
    async fetchHistoricalPrice(selectedDate) {
      this.store.date = selectedDate;
      this.errorMessage = '';

      // Fetches current price if date is cleared
      if (!selectedDate) {
        this.historicalPrice = null;
        this.fetchCurrentPrice();
        return;
      }

      try {
        this.historicalPrice = await fetchHistoricalPrice(this.store.selectedCoin, this.store.date);
      } catch {
        this.handleError();
      }
    },
    handleCoinChanged(selectedCoin) {
      this.store.selectedCoin = selectedCoin;
      this.store.date
        ? this.fetchHistoricalPrice(this.store.date)
        : this.fetchCurrentPrice();
    },
    handleError() {
      this.errorMessage = 'Wait a minute before making more requests.';
    },
  },
};
</script>
